import { action, thunk, persist } from 'easy-peasy';
import { httpGetCompanies } from "services/companies"

const model = {
  loading: false,
  setLoading: action((state, payload) => {
    state.loading = payload
  }),
  count: 0,
  setCount: action((state, payload) => {
    state.count = payload
  }),
  // My companies list
  companies: [],
  setCo: action((state, payload) => {
    if (payload) {
      state.companies = payload
    }
  }),
  getCompanies: thunk(async (actions, payload) => {
    actions.setLoading(true)
    httpGetCompanies().then(response => {
      if (response.status === 200 && response?.data) {
        const raw = response.data
        const list = Array.isArray(raw) ? raw : (raw.results || [])
        actions.setCo(list)
        actions.setCount(list.length)
      }
    }, error => {
      
    }).finally(() => {
      actions.setLoading(false)
    })
    
  }),
  // Selected account

};

export default model;